import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchWrapper } from "../utils/fetchWrapper";

// /media/ashish/60F043A90F90EE2D/Work/MC/MC-Frontend/src/redux/image.js

// Async thunk to request a screenshot for a domain
export const generateImage = createAsyncThunk(
    "image/generateImage",
    async (domain, { rejectWithValue }) => {
        try {
            // call backend route that returns { url: "/tmp/example.com.png" } or similar
            const res = await fetchWrapper.post("/image", { domain }, { withCredentials: true });

            // normalize response (fetchWrapper may return axios-like or plain data)
            const data = res?.data ?? res;
            if (!data || !data.url) {
                return rejectWithValue(data?.message || "No image URL returned");
            }

            return { domain, url: data.url };
        } catch (err) {
            return rejectWithValue(err?.message || "Failed to generate image");
        }
    }
);

const imageSlice = createSlice({
    name: "image",
    initialState: {
        images: {},        // cache: { [domain]: url }
        current: null,     // { domain, url }
        loading: false,
        error: null,
    },
    reducers: {
        clearCurrent: (state) => {
            state.current = null;
            state.error = null;
        },
        removeImage: (state, action) => {
            const domain = action.payload;
            if (domain && state.images[domain]) {
                delete state.images[domain];
                if (state.current?.domain === domain) state.current = null;
            }
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(generateImage.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(generateImage.fulfilled, (state, action) => {
                state.loading = false;
                state.error = null;
                const { domain, url } = action.payload;
                state.images[domain] = url;
                state.current = { domain, url };
            })
            .addCase(generateImage.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error?.message || "Error";
            });
    },
});

export const { clearCurrent, removeImage } = imageSlice.actions;

export default imageSlice.reducer;